import type { SvgIconProps } from "@/types/svg";

export function ToastMessageIcon(props: SvgIconProps) {
    return (
        <svg
            aria-hidden="true"
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            fill="none"
            viewBox="0 0 24 24"
            {...props}
        >
            <path
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="m12 18-7 3 7-18 7 18-7-3Zm0 0v-5"
            />
        </svg>
    );
}
